// We need to use default import here to avoid issues with the mixpanel library
/* eslint-disable import/no-named-as-default-member */
import mixpanel from "mixpanel-browser";
import { getRoleFromToken } from "utils/auth";
import { getTraceId } from "utils/get-trace-id";

const shouldInitialiseMixpanel = () => {
  const isUK = window.location.pathname.startsWith("/uk");

  if (!isUK) {
    // Initialise for all non-UK users
    return true;
  }

  const role = getRoleFromToken();

  if (role === "agent" || role === "agent_manager") {
    // For UK - only initialise for agents
    return true;
  }

  return false;
};

let isMixpanelEnabled = false;

export const initialiseMixpanel = () => {
  if (import.meta.env.VITE_MIXPANEL_API_KEY && shouldInitialiseMixpanel()) {
    mixpanel.init(import.meta.env.VITE_MIXPANEL_API_KEY, {
      debug: false,
      track_pageview: "full-url",
      persistence: "localStorage",
      autocapture: {
        pageview: "full-url",
        click: true,
        input: true,
        scroll: false,
        submit: true,
        capture_text_content: true,
      },
    });

    mixpanel.register({
      traceId: getTraceId(),
    });

    isMixpanelEnabled = true;
  }
};

export const identifyMixpanelUser = (
  userId: string,
  properties: { region: string; name: string; email: string; roles: string[] },
) => {
  const { region, ...userProperties } = properties;
  if (isMixpanelEnabled) {
    mixpanel.register({ region });
    mixpanel.identify(userId);
    mixpanel.people.set(userProperties);
  } else {
    import.meta.env.DEV &&
      // eslint-disable-next-line no-console
      console.log(
        "Mixpanel is not enabled. User identification skipped.\n",
        JSON.stringify(properties, null, 2),
      );
  }
};
